// Centralized API paths and configuration
export const API_PATHS = {
  // Auth
  LOGIN: "auth/login",
  GOOGLE_LOGIN: "api/auth/google",

  // Users
  ALLOWED_USERS: "api/v1/allowed-users",
  
  // Warehouse
  LIST_WAREHOUSES: "api/v1/warehouses/list",
  
  // Projects
  GET_PROJECTS: "api/v1/projects/items",
  CREATE_PROJECT: "api/v1/projects/item",
  UPDATE_PROJECT: "api/v1/projects/update-item",
  DELETE_PROJECT: "api/v1/projects/delete_item",
  PROJECT_ROLES: "api/v1/projects/roles",
  PROJECT_TYPES: "api/v1/projects/types",
  PROJECT_WAREHOUSE_ACCESS: "api/v1/projects/warehouse-access",
  
  // Variants
  VARIANT: "api/v1/projects/variant",
  GET_VARIANTS: "api/v1/projects/variants",
  UPDATE_VARIANT: "api/v1/projects/update-variant",
  DELETE_VARIANT: "api/v1/projects/delete-variant",
  
  // Downloads
  GET_APPS: "api/v1/downloads/items",
  GET_APP: "api/v1/downloads/item",
  GENERATE_DOWNLOAD_URL: "api/v1/downloads/generate_download_url",
  GENERATE_LONG_DOWNLOAD_URL: "api/v1/downloads/generate_long_download_url",
  
  // Aggregates across every project the caller can see
  OVERVIEW_SUMMARY: "api/v1/overview/summary",
  UPLOADS_RECENT: "api/v1/uploads/recent",

  // Uploads
  GENERATE_UPLOAD_URL: "api/v1/uploads/generate_upload_url",
  UPLOAD_ITEM: "api/v1/uploads/item",
  DELETE_UPLOAD_ITEM: "api/v1/uploads/delete-item",
  GET_APPS_BY_PROJECT: "api/v1/uploads/items",
  UPLOAD_ROLES: "api/v1/uploads/roles",
  UPLOAD_TYPES: "api/v1/uploads/types",
  UPLOAD_WAREHOUSE_ACCESS: "api/v1/uploads/warehouse-access",

  // Test Builds — ephemeral, auto-deleted after 7 days. Parallel pipeline to
  // Uploads/Downloads, not a mode on it. Every endpoint here is a POST.
  TEST_BUILD_GENERATE_UPLOAD_URL: "api/v1/test-builds/generate_upload_url",
  TEST_BUILD_ITEM: "api/v1/test-builds/item",
  TEST_BUILD_ITEMS: "api/v1/test-builds/items",
  TEST_BUILD_ALL_ITEMS: "api/v1/test-builds/all-items",
  TEST_BUILD_DETAIL: "api/v1/test-builds/detail",
  TEST_BUILD_GENERATE_DOWNLOAD_URL: "api/v1/test-builds/generate_download_url",
  TEST_BUILD_DELETE_ITEM: "api/v1/test-builds/delete-item",
} as const;

export default API_PATHS;
